ready(function () {
    onChange();
    init();
});

// ready function
function ready(callbackFunc) {
    if (document.readyState !== 'loading') {
        // Document is already ready, call the callback directly
        callbackFunc();
    } else if (document.addEventListener) {
        // All modern browsers to register DOMContentLoaded
        document.addEventListener('DOMContentLoaded', callbackFunc);
    } else {
        // Old IE browsers
        document.attachEvent('onreadystatechange', function () {
            if (document.readyState === 'complete') {
                callbackFunc();
            }
        });
    }
}

// event handler
function init() {
    var ids = ["width", "repeat", "room-size-long", "room-size-short"];
    for (var i = 0; i < ids.length; i++) {
        var elm = document.getElementById(ids[i])
        elm.addEventListener('input', onChange);
        elm.addEventListener('change', onChange);
    }
}

function onChange() {
    var width = intValue('width');
    var repeat = intValue('repeat');
    var roomLong = intValue('room-size-long');
    var roomShort = intValue('room-size-short');

    var errors = [];
    if (!width) {
        errors.push('クッションフロアの横幅を入力してください。');
    }
    if (repeat == null) {
        errors.push('クッションフロアのタテリピート数を入力してください。');
    }
    if (!roomLong) {
        errors.push('お部屋の長い方のサイズを入力してください。');
    }
    if (!roomShort) {
        errors.push('お部屋の短い方のサイズを入力してください。');
    }
    if (errors.length) {
        showErrors(errors);
        hideResult();
        return;
    }
    var result = calculate(width, repeat, roomLong, roomShort);
    if (!result) {
        showErrors(['入力してください。']);
        hideResult();
        return;
    }
    hideErrors();
    showResult(result);
}
function showErrors(errors) {
    element("result-warning").innerHTML = '<p>' + errors.join("\n<p>");
    element("result-warning").style.display = 'block';
}
function hideErrors() {
    element("result-warning").innerHTML = '';
    element("result-warning").style.display = 'none';
}
function showResult(result) {
    element("result-box").innerHTML = String(result) + " cm";
    element("result").style.display = 'block';
}
function hideResult() {
    element("result-box").innerHTML = "";
    element("result").style.display = 'none';
}

function element(id) {
    return document.getElementById(id);
}
function value(id) {
    return element(id).value;
}
function intValue(id) {
    return toInt(value(id));
}
function toInt(x) {
    var parsed = parseInt(x, 10);
    if (isNaN(parsed)) { return null; }
    return parsed;
}

// calc
function calculate(width, repeat, roomLong, roomShort) {
    if (!width || repeat == null || !roomLong || !roomShort) {
        return false;
    }
    var numLines = Math.ceil(roomShort / width);
    length = (roomLong + 20) * numLines + repeat * (numLines - 1);
    return Math.ceil(length * 0.1) * 10
}

